import { Box, Grid } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import Button from '../../../../components/button/button.component';
import { Link, useNavigate } from 'react-router-dom';
import Checkbox from '../../../../components/checkbox/checkbox.component';
import { CancelContext } from '../../../../contexts/cancellation.context';
import { pauseSubscription } from '../../../../utils/recurly.functions';
import { addError, freshDeskReport, removeErrorConfirm } from '../../../../utils/generaFunctions';

const PauseMain = () => {
    const {userInfo, getPauseOption, changeCancelInfo, setLoading} = useContext(CancelContext);
    const navigate = useNavigate();
    const options = getPauseOption();
    const [choice, setChoice] = useState(null);
    useEffect(()=>{
        if(choice!==null){
            changeCancelInfo({pause:options[choice].value});
            removeErrorConfirm();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[choice]);
    return (
        <Grid container className='main-container'>
            <Grid container item className='flex-vertical' xs={12}>
                <div>
                    <Grid item className='title' xs={12}>
                        <h1>Choose pause duration</h1>
                    </Grid>
                    <Grid item className='desc' xs={12}>
                        Hit pause and take a break for a few months. You subscription will automatically continue after the pause.
                    </Grid>
                </div>
                <Grid item id='option-container'>
                    {options && options.map((option, index) => {
                        return (
                            <Box key={`pause_option${index}`} className={`box ${choice === index? "selected":"not-selected"}`} onClick={()=>{setChoice(index);}}>
                                <div className='small-header'>Pause for {option.text}</div>
                                <Checkbox key={"checkbox"+index} checked={choice===index} large={true}/>
                            </Box>
                        )
                    })}
                </Grid>
                <Grid item id='button-container'>
                    <Link 
                        className={`button-link`} 
                        onClick={()=>{
                            if(!options[choice]){
                                addError(document.getElementById('option-container'), 'Select one of the options above first and then click continue');
                            } else{
                                setLoading(true);
                                pauseSubscription(userInfo.email, options[choice].value).then((resultJSON)=>{
                                    if(resultJSON.active){
                                        const end_of_term = new Date(resultJSON.reactive_limit.date.split(" ")[0]);
                                        var renew_date;
                                        if(userInfo.plan_code.search("-a") > 0){
                                            let days = (choice+1) * 14;
                                            renew_date = new Date(end_of_term.setDate(end_of_term.getDate()+days));
                                        } else if(userInfo.plan_code.search("-s") > 0){
                                            let months = (choice+1);
                                            renew_date = new Date(end_of_term.setMonth(end_of_term.getMonth()+months));
                                        } else if(userInfo.plan_code.search("-e") > 0){
                                            let months = (choice+1)*2;
                                            renew_date = new Date(end_of_term.setMonth(end_of_term.getMonth()+months));
                                        } else if(userInfo.plan_code.search("-q") > 0){
                                            let months = (choice+1)*3;
                                            renew_date = new Date(end_of_term.setMonth(end_of_term.getMonth()+months));
                                        } 
                                        renew_date = new Date(renew_date.getFullYear() + "-" + (renew_date.getMonth()+1) + "-" +renew_date.getDate());
                                        let options = { year: 'numeric', month: 'long', day: 'numeric' };
                                        changeCancelInfo({renew_date:renew_date.toLocaleDateString("en-US", options)});
                                        freshDeskReport(userInfo.email, userInfo.name, "Paused for " + (choice+1) + " cycle", "Sys2.0: Prevented", "Sys2.0: Prevented", "Sys2.0: Paused").then(
                                            (response)=> {
                                            navigate("paused"+window.location.search);
                                        }).catch((e)=>{
                                            navigate("paused"+window.location.search);
                                        });
                                    } else {
                                        navigate("paused"+window.location.search);
                                    }
                                }).catch(()=>{
                                    navigate("paused"+window.location.search);
                                })
                                }
                        }}
                    ><Button text="confirm"></Button></Link>
                    <Link className={`button-link`} to={"../keep"+window.location.search}><Button className="btn-reverse" text={"Keep my subscription as-is"}/></Link>
                </Grid>
                <Link className='go-back' to={'../'+window.location.search}>&lt;&lt; BACK TO PREVIOUS PAGE</Link>
            </Grid>
        </Grid>
    )
}

export default PauseMain;